export const LONGMAX_PWD = 25;
export const LONGMIN_PWD = 4;
export const LONGMIN_STRONGPWD = 8;

const PASS_PATTERN = /^([a-zA-Z0-9!#$%&()*+,./:;=@{|}\[\]\-_])+$/;

export function isValidPassword(pass = '') {
  return !!pass && pass.length <= LONGMAX_PWD && PASS_PATTERN.test(pass);
}
